"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeProductQuantity = void 0;
const React = require("react");
const NumberInput_1 = require("../../../../../components/base/inputs/NumberInput");
const styles = require("./styles.scss");
const cssComposer_1 = require("../../../../../helpers/cssComposer");
const css = (0, cssComposer_1.default)(styles, "ChangeProductQuantity");
/**
 * Input to change quantity of a product in the cart
 */
const ChangeProductQuantity = ({ salesOrderItem, onInputChange }) => (React.createElement("div", { className: css("") },
    React.createElement(NumberInput_1.NumberInput, { onInputChange: onInputChange, value: salesOrderItem.quantity, incrementValue: 1, minValue: 1, hideKeypad: true })));
exports.ChangeProductQuantity = ChangeProductQuantity;
//# sourceMappingURL=index.js.map